import React from "react";

// @mui
import { styled } from '@mui/material/styles';

// component
import functionlist from '../../../image/img_funclist.png'



const Div = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding : 80,
  backgroundColor: theme.palette.background.default,
}));

const LI = styled('li')(() => ({
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  marginTop:'10px'
}));

export default function FreePlan( { data } ) {


  return (
    <>
        
          <div style={{display :'flex'}}><p style={{ color : "rgb(26 158 248)" }}>접속 계정&nbsp;&nbsp;</p><p>{data}</p></div>
          <p style={{fontSize :'x-large', fontWeight : '700', marginTop: 30, marginBottom:10}}>베이직 플랜(Basic Plan)</p>
          <p>기공소를 운영하기에 완벽해요. 기공소를 위한 표준 기능</p>
          <div style={{marginTop: 30}}>
            <span style={{fontWeight : '900', fontSize :'large'}}>주요기능</span>
            <div style={{marginTop: 10}}>
                <div>
                    <ul>
                                   <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>접수 월 500건 무료 제공</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>청구서 월 500건 무료 발행</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>거래처 등록 무제한</p></LI>
                                    <LI><img src={functionlist} alt='functionlist' /><p style={{ paddingLeft: '5px' }}>구성원 5명까지 추가 등록</p></LI>
                    </ul>
                    
                </div>
            </div>
          </div>
        
    </>
  );
}
